import React, { ReactNode, MouseEvent } from 'react'
import ScrollToComponent from 'scroll-to'

type ScrollToProps = {
  to: string;
  children: ReactNode;
  styles?: string;
}

function scrollTo (evt: MouseEvent<HTMLAnchorElement>) {
  evt.preventDefault()
  const topElement = document.getElementById(evt.currentTarget.hash.replace('#', ''))
  if (!topElement) { return }
  const offsetTopElem = topElement.getBoundingClientRect()
  const top = offsetTopElem.top + window.scrollY - 70
  ScrollToComponent(0, top, {
    ease: 'in-out-quad',
    duration: 1100,
  })
}

function ScrollTo ({ to, children, styles }: ScrollToProps) {
  return (
    <a href={to} onClick={scrollTo} className={styles}>
      {children}
    </a>
  )
}

export default ScrollTo
